var _rect, _path, _path2, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmex24X16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12.0926V14H21.6498L20.7812 12.9527L19.8786 14H13.2026V8.42419H11L13.7533 2H16.4327L17.0799 3.45685V2H20.4066L20.9629 3.52706L21.5079 2H24V2.90687H22.0755L21.2013 5.28232L20.9686 5.92589L19.8502 2.90687H17.9258V7.58751L15.9275 2.90687H14.3777L12.3681 7.58751H13.6852L14.0371 6.6865H16.2398L16.5917 7.58751H17.9258H19.0839V4.53925L19.0782 3.92491L19.3053 4.53925L20.4122 7.58751H21.5135L22.6262 4.53925L22.8419 3.93077V7.58751H24V9.41882L22.717 10.7469L24 12.0926ZM14.1336 13.0931V8.43001H17.9258V9.44223H15.2917V10.2613H17.8747V11.2677H15.2917V12.0809H17.9258V13.0931H14.1336ZM23.6481 13.0931H22.1437L20.7699 11.5719L19.3904 13.0931H17.9258L20.0432 10.7703L17.9258 8.43001H19.4358L20.7983 9.9454L22.1664 8.43001H23.6481L21.5249 10.7528L23.6481 13.0931Z",
    fill: "#016FD0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1384 3.90736L14.9114 4.49246L14.4402 5.67429H15.8367L15.3655 4.49246L15.1384 3.90736Z",
    fill: "#016FD0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 15,
    rx: 1.5,
    stroke: "black",
    strokeOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex24X16);
export default __webpack_public_path__ + "static/media/amex24x16.9676d86b169ded11e2618a88c8ecdede.svg";
export { ForwardRef as ReactComponent };